import { Source, Layer } from 'react-map-gl';
import { sourceProps } from './source-utils';

export function MunicipiosLayer({ url }: { url: string }) {
  return (
    <Source id="municipios" {...sourceProps(url)}>
      <Layer
        id="municipios-casing"
        type="line"
        paint={{ 'line-color': 'rgba(0,0,0,0.55)', 'line-width': 5, 'line-opacity': 0.7 }}
      />
      <Layer
        id="municipios-outline"
        type="line"
        paint={{ 'line-color': '#FFFFFF', 'line-width': 1.8, 'line-opacity': 0.85, 'line-dasharray': [12, 5] }}
      />
    </Source>
  );
}
